export default class MessageService {

}
